<template>
  <button class="BtnOrange_BtnOrange" @click="clickBtn">
    <slot />
  </button>
</template>
<script>
export default {
  name: "BtnOrange",
  methods: {
    clickBtn() {
      this.$emit("clickBtn");
    },
  },
};
</script>

<style scoped lang="scss">
.BtnOrange {
  &_BtnOrange {
    width: 109px;
    height: 30px;
    background: #ff8000;
    box-sizing: border-box;
    border-radius: 5px;
    color: #ffffff;
    font-weight: 700;
    font-size: 14px;

    &:hover {
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    }
    &:active {
      box-shadow: 0 0;
    }
  }
}
</style>
